// eslint-disable-next-line no-unused-vars
import React from 'react';
import { node, bool, func, string } from 'prop-types';
import { Button, Search } from '@carbon/react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { ChevronDown } from 'lucide-react';

const StyledSearch = styled(Search)`
  margin: 5px 0;
  .cds--search-input {
    border: 1px solid ${ props => props.theme.products.colors.border };
    border-radius: 4px;
    background-color: transparent;
  }
`;

const FilterListComponent = ({ children, showSearch, onSearch, filterTitle, onToggle, cx }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <div className={ `filterGroup ${cx}` }>
      <div className="header">
        <h3 className="filterTitle">{ filterTitle }</h3>
        <Button onClick={ onToggle } kind="ghost" className="close">
          <ChevronDown />
        </Button>
      </div>
      { showSearch && (
        <StyledSearch
          theme={ theme }
          size="sm"
          labelText=""
          placeholder={ t('common.search.search') }
          onChange={ onSearch }
        />
      ) }
      { children }
    </div>
  );
};

FilterListComponent.propTypes = {
  children: node,
  filterTitle: string,
  showSearch: bool,
  onSearch: func,
  onToggle: func,
  cx: string
};

export default FilterListComponent;
